
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Coins, MapPin, Phone, Truck, Star, Building } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const AchatMetauxTarn = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Achat Métaux Tarn (81) - Rachat Fer Cuivre Albi Castres | Groupe Fabre"
        description="Rachat de métaux dans le Tarn : fer, cuivre, aluminium, inox. Service Albi, Castres, Mazamet. Pesée certifiée et paiement immédiat."
        canonical="/nos-services/achat-metaux/tarn"
        keywords="achat métaux Tarn, rachat cuivre Albi, ferraille 81, métaux Castres Mazamet"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <div className="flex items-center mb-4">
                <Building className="h-12 w-12 mr-4" />
                <div>
                  <h1 className="text-4xl md:text-5xl font-bold">Achat Métaux Tarn (81)</h1>
                  <p className="text-xl mt-2 opacity-90">Rachat de métaux ferreux et non ferreux dans le Tarn</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-bold text-fabre-gray mb-6">
                  Rachat de métaux dans le Tarn
                </h2>
                <p className="text-gray-600 mb-6">
                  <strong>Groupe Fabre Environnement</strong> propose ses services d'achat de métaux 
                  dans tout le <strong>Tarn</strong>. Nous intervenons à Albi, 
                  Castres, Mazamet et dans toutes les communes du département 81.
                </p>
                
                <h3 className="text-xl font-bold text-fabre-gray mb-4">Zones d'intervention Tarn</h3>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-red-600 mr-3 mt-1" />
                    <span><strong>Albi :</strong> ville UNESCO et alentours</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-red-600 mr-3 mt-1" />
                    <span><strong>Castres :</strong> centre industriel</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-red-600 mr-3 mt-1" />
                    <span><strong>Mazamet :</strong> secteur textile historique</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-red-600 mr-3 mt-1" />
                    <span><strong>Gaillac :</strong> zone viticole et industrielle</span>
                  </li>
                </ul>

                <div className="bg-red-50 border border-red-200 p-6 rounded-lg">
                  <h4 className="font-bold text-red-800 mb-3">Spécialités Tarn</h4>
                  <ul className="text-red-700 text-sm space-y-2">
                    <li>• Métaux issus de l'industrie textile</li>
                    <li>• Ferraille de démolition patrimoniale</li>
                    <li>• Cuivre d'installations anciennes</li>
                    <li>• Métaux agricoles et viticoles</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-fabre-gray mb-6">Expertise Tarn</h3>
                <p className="text-gray-600 mb-6">
                  Notre connaissance du patrimoine industriel tarnais nous permet 
                  de valoriser au mieux vos métaux historiques et contemporains.
                </p>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <Building className="h-5 w-5 text-red-600 mr-3" />
                    <span>Expertise patrimoine</span>
                  </div>
                  <div className="flex items-center">
                    <Coins className="h-5 w-5 text-red-600 mr-3" />
                    <span>Valorisation optimale</span>
                  </div>
                  <div className="flex items-center">
                    <Truck className="h-5 w-5 text-red-600 mr-3" />
                    <span>Déplacement Tarn</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-red-600 mr-3" />
                    <span>Service personnalisé</span>
                  </div>
                </div>

                <Link to="/contact" className="block">
                  <button className="w-full px-6 py-3 bg-red-600 text-white rounded-md font-medium hover:bg-red-700 transition-colors">
                    Demander un devis Tarn
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AchatMetauxTarn;
